import React from "react";
import styles from "./VarianceValue.module.scss";
import { useAppSelector } from "../../../redux/hooks";
import Icon from "../Icon/Icon";

export type VarianceDataType = "percentage" | "number" | "currency" | undefined;

interface VarianceValueProps {
  value: number | null | undefined;
  dataType?: VarianceDataType;
  currency?: string | null;
  comparisonCriteria?: string | null;
  className?: string;
}

const VarianceValue: React.FC<VarianceValueProps> = ({
  value,
  dataType,
  currency,
  comparisonCriteria,
  className,
}) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  if (value === null || value === undefined) return null;

  const isPositive = value > 0;
  const isNegative = value < 0;
  const absVal = Math.abs(value);

  const showDollar = dataType === "currency" && currency === "USD";
  const showPercent = dataType === "percentage";

  const themeClass = currentTheme === "dark" ? styles.dark : styles.light;

  const colorVar = isPositive
    ? 'var(--text-text-positive, #B3D67B)'
    : isNegative
    ? 'var(--text-text-negative, #F16A81)'
    : undefined;

  return (
    <span className={`${styles.wrapper} ${themeClass} ${className || ""}`.trim()}>
      {value !== 0 && (
        <span style={{ color: colorVar }}>
          {isPositive ? (
            <Icon
              name="up_filled_arrow_table"
              size={12}
              color={'var(--text-text-positive, #B3D67B)'}
              className={styles.search_icon}
            />
          ) : (
            <Icon
              name="down_filled_arrow_table"
              size={12}
              color={'var(--text-text-negative, #F16A81)'}
              className={styles.search_icon}
            />
          )}
        </span>
      )}
      <span
        className={`${styles.value} ${isPositive ? styles.positive : isNegative ? styles.negative : ""}`.trim()}
        style={{ color: colorVar }}
      >
        {showDollar && "$"}
        {absVal}
        {showPercent && "%"}
      </span>
      {comparisonCriteria && (
        <span className={styles.unit}>{comparisonCriteria?.toUpperCase()}</span>
      )}
    </span>
  );
};

export default VarianceValue;
